import React from 'react';
import { useSelector } from 'react-redux';
import { authorizationSelector} from '../store/reducers/auth';

export default function Authorization({ children, auth = false }) {
    const authorization = useSelector(authorizationSelector);
    const flag = auth ? authorization : !authorization;
    return <>{flag && children}</>;
}
